import PropTypes from 'prop-types';
import React from 'react';
import ReactSVG from 'react-svg';
import {CloseBtn} from './styles';
import { LIGHT_GREY } from '../../config/colors';


const FormCloseIcon = (props) => (
  <CloseBtn onClick={props.onClick}>
    <ReactSVG style={{fill: LIGHT_GREY }} path={require('./icons/close-button.svg')} role="logo" alt="close"/>
  </CloseBtn>
);

FormCloseIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  styleName: PropTypes.string.isRequired
};

export default FormCloseIcon;



// WEBPACK FOOTER //
// ./src/components/LoginForm/FormCloseIcon.jsx